import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { breakpoints } from '../../../utils/responsive_utilities';

const DeviceLayoutManager = ({ children, elements, appearance }) => {
  // appearance is initial appearance we set in elements option when initialising
  // now based on device screen size changed update appearance object in elements object while keeping
  // the same instance of payment element.

  const isSmallScreen = useMediaQuery({
    query: `(max-width: ${breakpoints.sm}px)`,
  });
  let newAppearance = appearance;
  if (isSmallScreen) {
    newAppearance = {
      ...appearance,
      rules: {
        ...appearance.rules,
        '.Label': {
          ...appearance.rules['.Label'],
          fontSize: '10px',
        },
        '.Input': {
          ...appearance.rules['.Input'],
          fontSize: '12px',
        },
        '.Error': {
          ...appearance.rules['.Error'],
          fontSize: '10px',
        },
      },
    };
  }

  // elements.update() is not available in old web-ui stripe library so updated version
  elements.update({ appearance: newAppearance });

  return <>{children}</>;
};

export default DeviceLayoutManager;
